import { c as _c } from "react/compiler-runtime";
import { useMutation } from '@apollo/client/react';
import { Box, Button, Link, Spinner } from '@chakra-ui/react';
import { useToast } from '@src/components/chakra-ui/use-toast';
import { stripMarkdownWhitespace } from '@src/components/sco/Chat/ChatMessageComposer';
import { CommentPendingAttachments, COMMENT_STORED_FILES_SELECTION, useCommentAttachments } from '@src/components/sco/Comments/CommentAttachments';
import { RichMarkdownInput } from '@src/components/sco/RichMarkdownInput';
import { ScoComment } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import React, { useState } from 'react';
type CommentEditorProps = {
  comment: ScoComment;
  onSuccess: () => void;
  onCancel: () => void;
  onError: () => void;
};
export const CommentEditor = props => {
  const $ = _c(38);
  const {
    comment
  } = props;
  const [body, setBody] = useState(comment.body);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = CommentEditor.mutations.updateComment();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [updateComment] = useMutation(t0);
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();
  const t1 = comment.storedFiles?.items;
  let t2;
  if ($[1] !== t1) {
    t2 = {
      initialFiles: t1
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    pendingFiles,
    addFile,
    removeFile,
    isUploading,
    isFull,
    storedFileIds
  } = useCommentAttachments(t2);
  let t3;
  if ($[3] !== body || $[4] !== isUploading || $[5] !== props || $[6] !== storedFileIds || $[7] !== toast || $[8] !== updateComment) {
    t3 = async () => {
      const hasBody = stripMarkdownWhitespace(body || "").length > 0;
      if (!hasBody && storedFileIds.length === 0 || isUploading) {
        return;
      }
      await setIsLoading(true);
      ;
      try {
        await updateComment({
          variables: {
            input: {
              commentId: props.comment.commentId,
              body,
              storedFileIds
            }
          }
        });
        await props.onSuccess();
        toast({
          title: "Comment has been updated.",
          isClosable: true,
          status: "info",
          containerStyle: {
            color: "black"
          }
        });
      } catch (t4) {
        const err = t4;
        console.log(err);
        props.onError();
      }
      await setIsLoading(false);
    };
    $[3] = body;
    $[4] = isUploading;
    $[5] = props;
    $[6] = storedFileIds;
    $[7] = toast;
    $[8] = updateComment;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const onSave = t3;
  const t4 = isFull || isUploading || isLoading;
  let t5;
  if ($[10] !== props) {
    t5 = <Link key="cancel-link" color="purpleLight !important" fontFamily="Poppins" fontSize="xs" fontWeight="semibold" justifySelf="flex-end" letterSpacing="-0.25px" textDecoration="none !important" onClick={() => props.onCancel && props.onCancel()}>Cancel</Link>;
    $[10] = props;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== onSave) {
    t6 = () => onSave();
    $[12] = onSave;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== isLoading || $[15] !== isUploading) {
    t7 = isLoading || isUploading ? <Spinner /> : "Save";
    $[14] = isLoading;
    $[15] = isUploading;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== isUploading || $[18] !== t6 || $[19] !== t7) {
    t8 = <Button key="save-button" disabled={isUploading} justifySelf="flex-end" marginLeft="auto" marginRight="4px" size="xs" variant="cta" onClick={t6}>{t7}</Button>;
    $[17] = isUploading;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t5 || $[22] !== t8) {
    t9 = [t5, t8];
    $[21] = t5;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  let t11;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      borderColor: "purpleLightAlpha.500",
      borderRadius: "lg"
    };
    t11 = values => setBody(values.markdown);
    $[24] = t10;
    $[25] = t11;
  } else {
    t10 = $[24];
    t11 = $[25];
  }
  let t12;
  if ($[26] !== addFile || $[27] !== comment.body || $[28] !== t4 || $[29] !== t9) {
    t12 = <RichMarkdownInput enableFileAttachments={true} fileAttachmentsDisabled={t4} initialMarkdownValue={comment.body} placeholder="Enter the details..." additionalToolbarButtons={t9} boxProps={t10} onChange={t11} onFileAttachmentSelected={addFile} />;
    $[26] = addFile;
    $[27] = comment.body;
    $[28] = t4;
    $[29] = t9;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== isLoading || $[32] !== pendingFiles || $[33] !== removeFile) {
    t13 = <CommentPendingAttachments disabled={isLoading} files={pendingFiles} onRemove={removeFile} />;
    $[31] = isLoading;
    $[32] = pendingFiles;
    $[33] = removeFile;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== t12 || $[36] !== t13) {
    t14 = <Box>{t12}{t13}</Box>;
    $[35] = t12;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  return t14;
};
CommentEditor.mutations = {
  updateComment: () => gql`
    mutation($input: UpdateCommentInput!) {
      updateComment(input: $input) {
        comment {
          id
          ${CommentEditor.fragments.ScoComment()}
        }
      }
    }
  `
};
CommentEditor.fragments = {
  ScoComment: () => gql`
    fragment _ on ScoComment {
      id
      body
      updatedAt
      ${COMMENT_STORED_FILES_SELECTION}
    }
  `
};